import { html, LitElement, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import style from './ui-clock-icon.css?inline';
import '../ui-inlined-svg/ui-inlined-svg';

const CName = 'ui-clock-icon';

@customElement(CName)
export class UIClockIcon extends LitElement {
  static readonly styles = unsafeCSS(style);

  @property({ type: String }) class = '';

  render() {
    // Use vite to transform static URL
    const assetUrl = new URL('/assets/ui-core/icons/clock-icon.svg', import.meta.url).href;
    return html`
      <ui-inlined-svg class="clock-icon ${this.class}" .defer=${true} .src=${assetUrl}></ui-inlined-svg>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UIClockIcon;
  }
}
